import { createContext, useContext, useState } from "react";

const MobileMenuContext = createContext();

export function MobileMenuProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MobileMenuContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </MobileMenuContext.Provider>
  );
}

export function useMobileMenu() {
  const context = useContext(MobileMenuContext);
  if (!context) {
    // Return default values if context is not available (for backward compatibility)
    return { isOpen: false, setIsOpen: () => {} };
  }
  return context;
}

